import { Camera, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router";

const shopLinks = [
  "Handmade Soaps",
  "Hair Care",
  "Hair Colour",
  "Lip Care",
  "Gift Hampers"
];

const companyLinks = [
  "Our Story",
  "Making RiNi",
  "Ingredients",
  "Contact",
  "FAQs"
];

export function Footer() {
  return (
    <footer className="bg-[#30231f] text-white">
      <div className="rini-container grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Link
            to="/"
            className="inline-block"
          >
            <span className="block font-serif text-4xl font-semibold tracking-[0.08em]">
              RiNi
            </span>
            <span className="block text-[10px] tracking-[0.35em] text-[#b8c9aa]">
              BODYCARE
            </span>
          </Link>

          <p className="mt-6 max-w-sm leading-7 text-white/65">
            Thoughtfully handcrafted bodycare, haircare and gifting products
            made with care.
          </p>

          <a
            href="https://www.instagram.com/rini_bodycare/"
            target="_blank"
            rel="noreferrer"
            className="mt-6 inline-flex items-center gap-2 text-white/80"
          >
            <Camera size={19} />
            @rini_bodycare
          </a>
        </div>

        <div>
          <h3 className="font-serif text-xl">Shop</h3>

          <div className="mt-5 space-y-3">
            {shopLinks.map((link) => (
              <Link
                key={link}
                to="/shop"
                className="block text-sm text-white/65 transition hover:text-white"
              >
                {link}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-serif text-xl">About RiNi</h3>

          <div className="mt-5 space-y-3">
            {companyLinks.map((link) => (
              <Link
                key={link}
                to="/"
                className="block text-sm text-white/65 transition hover:text-white"
              >
                {link}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-serif text-xl">Contact</h3>

          <div className="mt-5 space-y-4 text-sm text-white/65">
            <p className="flex items-start gap-3">
              <Phone
                size={18}
                className="mt-0.5 shrink-0"
              />
              Contact number will be added
            </p>

            <p className="flex items-start gap-3">
              <Mail
                size={18}
                className="mt-0.5 shrink-0"
              />
              support@rinibodycare.com
            </p>

            <p className="flex items-start gap-3">
              <MapPin
                size={18}
                className="mt-0.5 shrink-0"
              />
              Karnataka, India
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="rini-container flex flex-col gap-4 py-6 text-sm text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {new Date().getFullYear()} RiNi Bodycare. All rights reserved.
          </p>

          <div className="flex flex-wrap gap-5">
            <Link to="/">Privacy Policy</Link>
            <Link to="/">Shipping Policy</Link>
            <Link to="/">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
